import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { API } from '../config';
import { tr } from '../til';
import { adminmi, tanlanganTuman, tumanniTanla } from '../foydalanuvchi';
import YolKorsat from '../components/YolKorsat';

const card = {
  background: '#fff',
  borderRadius: '12px',
  padding: '24px',
  boxShadow: '0 1px 8px rgba(0,0,0,0.06)'
};

const inputStyle = {
  padding: '10px 12px',
  border: '1px solid #ddd',
  borderRadius: '8px',
  fontSize: '14px',
  width: '100%',
  boxSizing: 'border-box'
};

const smallBtn = {
  padding: '6px 12px',
  background: '#eef1f7',
  color: '#1a1a2e',
  border: '1px solid #ddd',
  borderRadius: '8px',
  fontSize: '12px',
  cursor: 'pointer'
};

// Jazo turlari — utils/muddat.js dagi JAZO_TURLARI bilan bir xil bo'lishi shart.
// Manba: 403-son buyruq Yo'riqnomasi.
const JAZO_TURLARI = [
  {
    kod: 'ati', nom: tr("Axloq tuzatish ishlari"),
    sana: tr("Ish beruvchi xabarnomani olgan kun *"),
    izoh: tr("Boshqa joyda o'talsa — mahkum ishga chiqqan kun (63-band)"),
    soatmi: false
  },
  {
    kod: 'ochj', nom: tr("Ozodlikni cheklash"),
    sana: tr("Probatsiya hisobiga olingan kun *"),
    izoh: tr("Muddat shu kundan hisoblanadi (82-band)"),
    soatmi: false
  },
  {
    kod: 'shartli', nom: tr("Shartli hukm"),
    sana: tr("Hukm chiqarilgan kun *"),
    izoh: tr("Sinov muddati shu kundan hisoblanadi (107-band)"),
    soatmi: false
  },
  {
    kod: 'mji', nom: tr("Majburiy jamoat ishlari"),
    sana: null,
    izoh: tr("Muddat soat bilan o'lchanadi (37-band): kattalarga 120–480 soat, voyaga etmaganlarga 60–240 soat"),
    soatmi: true
  }
];

const turniOl = (kod) => JAZO_TURLARI.find(t => t.kod === kod) || null;

const emptyForm = () => ({
  familiya: '', ism: '', sharif: '', tugilgan_sana: '', jinsi: 'e',
  manzil: '', pinfl: '',
  sud_nomi: '', hukm_sanasi: '', ish_raqami: '', jk_moddasi: '', jazo_turi: '',
  jazo_turi_kod: '', jazo_yil: '', jazo_oy: '', jazo_kun: '',
  jazo_boshlangan: '', hisobga_olingan_kun: '', qoshilmaydigan_kun: '',
  jazo_soat: '', ishlangan_soat: '',
  nazoratga_olingan: '', izoh: ''
});

const toliqIsm = (m) => [m.familiya, m.ism, m.sharif].filter(Boolean).join(' ');

const sanaMatn = (v) => {
  if (!v) return '—';
  const d = new Date(v);
  return isNaN(d) ? '—' : d.toLocaleDateString('uz-UZ');
};

// Muddat holatiga qarab rang — ro'yxatda ko'zga tashlanib tursin.
const holatRangi = (h) => {
  if (!h || h.xato) return '#999';
  if (h.tugadimi) return '#c93636';
  if (h.qolgan_kun <= 30) return '#c47f17';
  return '#2d8a2d';
};

const Maydon = ({ label, children }) => (
  <div>
    <label style={{ display: 'block', fontSize: '12px', color: '#888', marginBottom: '5px' }}>
      {label}
    </label>
    {children}
  </div>
);

// Mahkum formasi — qo'shishda ham, tahrirlashda ham.
function MahkumForm({ form, setForm }) {
  const set = (field, value) => setForm({ ...form, [field]: value });
  const tur = turniOl(form.jazo_turi_kod);
  const grid = { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px', marginBottom: '18px' };

  return (
    <div>
      <h4 style={{ margin: '0 0 12px', fontSize: '13px', color: '#4f8ef7', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
        {tr("Shaxs")}
      </h4>
      <div style={grid}>
        <Maydon label={tr("Familiya *")}>
          <input type="text" value={form.familiya} onChange={e => set('familiya', e.target.value)} style={inputStyle} />
        </Maydon>
        <Maydon label={tr("Ism *")}>
          <input type="text" value={form.ism} onChange={e => set('ism', e.target.value)} style={inputStyle} />
        </Maydon>
        <Maydon label={tr("Sharifi")}>
          <input type="text" value={form.sharif} onChange={e => set('sharif', e.target.value)} style={inputStyle} />
        </Maydon>
        <Maydon label={tr("Tug'ilgan sana")}>
          <input type="date" value={form.tugilgan_sana || ''} onChange={e => set('tugilgan_sana', e.target.value)} style={inputStyle} />
        </Maydon>
        <Maydon label={tr("Jinsi")}>
          {/* Hujjat matnida "mahkum" va "mahkuma" deb turlicha yoziladi */}
          <select value={form.jinsi} onChange={e => set('jinsi', e.target.value)} style={inputStyle}>
            <option value="e">{tr("Erkak")}</option>
            <option value="a">{tr("Ayol")}</option>
          </select>
        </Maydon>
        <Maydon label={tr("JSHSHIR (14 raqam)")}>
          <input type="text" maxLength={14} value={form.pinfl} onChange={e => set('pinfl', e.target.value)} style={inputStyle} />
        </Maydon>
      </div>
      <div style={{ marginBottom: '18px' }}>
        <Maydon label={tr("Yashash manzili")}>
          <input type="text" value={form.manzil} onChange={e => set('manzil', e.target.value)} style={inputStyle} />
        </Maydon>
      </div>

      <h4 style={{ margin: '0 0 12px', fontSize: '13px', color: '#4f8ef7', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
        {tr("Hukm")}
      </h4>
      <div style={grid}>
        <Maydon label={tr("Sud nomi")}>
          <input type="text" value={form.sud_nomi} onChange={e => set('sud_nomi', e.target.value)} style={inputStyle} />
        </Maydon>
        <Maydon label={tr("Hukm sanasi")}>
          <input type="date" value={form.hukm_sanasi || ''} onChange={e => set('hukm_sanasi', e.target.value)} style={inputStyle} />
        </Maydon>
        <Maydon label={tr("Ish raqami")}>
          <input type="text" value={form.ish_raqami} onChange={e => set('ish_raqami', e.target.value)} style={inputStyle} />
        </Maydon>
        <Maydon label={tr("JK moddasi")}>
          <input type="text" placeholder={tr("168-modda 4-qismi «a» bandi")} value={form.jk_moddasi} onChange={e => set('jk_moddasi', e.target.value)} style={inputStyle} />
        </Maydon>
        <Maydon label={tr("Jazo turi")}>
          <input type="text" placeholder={tr("axloq tuzatish ishlari")} value={form.jazo_turi} onChange={e => set('jazo_turi', e.target.value)} style={inputStyle} />
        </Maydon>
      </div>

      <h4 style={{ margin: '0 0 12px', fontSize: '13px', color: '#4f8ef7', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
        {tr("Jazo muddati")}
      </h4>

      {/* Jazo turi butun hisobni belgilaydi: muddat qaysi kundan boshlanishi
          uch xil (63, 82, 107-bandlar), MJI esa umuman soat bilan o'lchanadi. */}
      <div style={{ marginBottom: '12px' }}>
        <Maydon label={tr("Jazo turi * — muddat qaysi kundan boshlanishini shu belgilaydi")}>
          <select value={form.jazo_turi_kod || ''} onChange={e => set('jazo_turi_kod', e.target.value)} style={inputStyle}>
            <option value="">{tr("Tanlanmagan — muddat hisoblanmaydi")}</option>
            {JAZO_TURLARI.map(t => <option key={t.kod} value={t.kod}>{t.nom}</option>)}
          </select>
        </Maydon>
      </div>

      {tur && (
        <div style={{
          background: '#f6f8fb', borderLeft: '3px solid #4f8ef7', borderRadius: '0 8px 8px 0',
          padding: '10px 14px', marginBottom: '14px', fontSize: '12px', color: '#555'
        }}>
          {tur.izoh}
        </div>
      )}

      {tur?.soatmi ? (
        // Majburiy jamoat ishlari — soat hisobi (37–39-bandlar).
        <div style={grid}>
          <Maydon label={tr("Tayinlangan soat *")}>
            <input type="number" min="0" placeholder="240" value={form.jazo_soat}
              onChange={e => set('jazo_soat', e.target.value)} style={inputStyle} />
          </Maydon>
          <Maydon label={tr("Ishlab bergan soat")}>
            <input type="number" min="0" value={form.ishlangan_soat}
              onChange={e => set('ishlangan_soat', e.target.value)} style={inputStyle} />
          </Maydon>
          <Maydon label={tr("Nazoratga olingan sana")}>
            <input type="date" value={form.nazoratga_olingan || ''}
              onChange={e => set('nazoratga_olingan', e.target.value)} style={inputStyle} />
          </Maydon>
        </div>
      ) : (
        <div style={grid}>
          <Maydon label={tr("Muddat — yil / oy / kun")}>
            <div style={{ display: 'flex', gap: '6px' }}>
              <input type="number" min="0" placeholder={tr("yil")} value={form.jazo_yil} onChange={e => set('jazo_yil', e.target.value)} style={inputStyle} />
              <input type="number" min="0" max="11" placeholder={tr("oy")} value={form.jazo_oy} onChange={e => set('jazo_oy', e.target.value)} style={inputStyle} />
              <input type="number" min="0" max="30" placeholder={tr("kun")} value={form.jazo_kun} onChange={e => set('jazo_kun', e.target.value)} style={inputStyle} />
            </div>
          </Maydon>
          <Maydon label={tur ? tur.sana : tr("Muddat boshlangan sana * (avval jazo turini tanlang)")}>
            <input type="date" value={form.jazo_boshlangan || ''} onChange={e => set('jazo_boshlangan', e.target.value)} style={inputStyle} />
          </Maydon>
          {/* "Hisobga olingan kun (tergov qamog'i)" va "Muddatga
              qo'shilmaydigan kun" maydonlari formadan OLIB TASHLANGAN
              (02.10.2026, buyurtmachi talabi): mahkumni ro'yxatga olish
              paytida bu raqamlar odatda ma'lum bo'lmaydi va forma
              uzayib ketgan edi.

              Server tomoni o'zgarmadi — ustunlar va muddat hisobi
              joyida qoldi. Shuning uchun avval kiritilgan kunlar
              yo'qolmaydi: tahrirlashda ular form holatida saqlanib,
              o'zgarishsiz qaytib boradi, muddat paneli esa ularni
              izohlab turadi. Kerak bo'lsa qaytarish — shu yerga
              maydonni qaytarish bilan bitadi. */}
          <Maydon label={tr("Nazoratga olingan sana")}>
            <input type="date" value={form.nazoratga_olingan || ''} onChange={e => set('nazoratga_olingan', e.target.value)} style={inputStyle} />
          </Maydon>
        </div>
      )}

      {/* "Izoh" maydoni ham olib tashlangan: hukm ma'lumoti rasmiy
          maydonlarda (sud nomi, hukm sanasi, ish raqami, JK moddasi)
          turadi, erkin matn esa hujjatda ishlatilmay qolardi. Saqlangan
          izohlar o'chmaydi — mahkum kartochkasida ko'rinib turadi. */}
    </div>
  );
}

// Muddat hisobi — maketdagi ko'rinish, hisob esa serverdan (utils/muddat.js).
function MuddatPaneli({ h }) {
  if (!h || h.xato) {
    return (
      <div style={{ background: '#fff8e6', color: '#8a6d2d', padding: '12px 14px', borderRadius: '10px', fontSize: '13px' }}>
        {h?.xato || tr("Muddat hisoblanmadi")} — {tr("hisob chiqishi uchun jazo boshlangan sana va muddat kiritilishi kerak.")}
      </div>
    );
  }

  const rang = holatRangi(h);

  // Majburiy jamoat ishlari — soat hisobi. Tugash sanasi yo'q va bo'lishi
  // ham mumkin emas (37-band), shuning uchun alohida ko'rinish.
  if (h.olchov === 'soat') {
    return (
      <div>
        <div style={{
          background: h.tugadimi ? '#e9f9ed' : '#f6f8fb',
          color: h.tugadimi ? '#2d8a2d' : '#1a1a2e',
          padding: '12px 14px', borderRadius: '10px',
          fontSize: '14px', fontWeight: '600', textAlign: 'center', marginBottom: '12px'
        }}>
          {h.tugadimi
            ? tr("Belgilangan soat to'liq ishlab berilgan")
            : tr("{ishlangan_soat} / {jami_soat} soat ishlab berildi", { ishlangan_soat: h.ishlangan_soat, jami_soat: h.jami_soat })}
        </div>

        <div style={{ height: '10px', background: '#f0f0f5', borderRadius: '5px', overflow: 'hidden', marginBottom: '6px' }}>
          <div style={{ width: `${h.foiz}%`, height: '100%', background: '#4f8ef7', transition: 'width .5s' }} />
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', color: '#999', marginBottom: '12px' }}>
          <span>{tr("Qolgan: {qolgan_matn}", { qolgan_matn: h.qolgan_matn })}</span>
          <span>{h.foiz}%</span>
        </div>

        <div style={{ background: '#fff8e6', color: '#8a6d2d', padding: '10px 14px', borderRadius: '8px', fontSize: '12px' }}>
          {h.izoh}
        </div>
      </div>
    );
  }

  const quti = (label, qiymat, tag, color) => (
    <div style={{ background: '#fafbfd', border: '1px solid #f0f0f5', borderRadius: '10px', padding: '12px' }}>
      <div style={{ color: '#999', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: '4px' }}>
        {label}
      </div>
      <div style={{ fontSize: '16px', fontWeight: '600', color: color || '#1a1a2e' }}>{qiymat}</div>
      {tag && <div style={{ color: '#aaa', fontSize: '11px', marginTop: '2px' }}>{tag}</div>}
    </div>
  );

  return (
    <div>
      <div style={{
        background: h.tugadimi ? '#ffeaea' : h.qolgan_kun <= 30 ? '#fff8e6' : '#e9f9ed',
        color: rang, padding: '12px 14px', borderRadius: '10px',
        fontSize: '14px', fontWeight: '600', textAlign: 'center', marginBottom: '12px'
      }}>
        {h.tugadimi
          ? tr("Jazo muddati tugagan")
          : h.qolgan_kun <= 30
            ? tr("Muddat tugashiga {qolgan_kun} kun qoldi", { qolgan_kun: h.qolgan_kun })
            : tr("Jazo o'talmoqda — {foiz}% bajarildi", { foiz: h.foiz })}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '10px' }}>
        {quti(tr("O'talgan muddat"), h.otalgan_matn, tr('{n} kun', { n: h.otalgan_kun }), '#2d8a2d')}
        {quti(tr("Qolgan muddat"), h.qolgan_matn, tr('{n} kun', { n: h.qolgan_kun }), '#c93636')}
        {quti(tr("Tugash sanasi"), sanaMatn(h.tugaydi), null, '#4f8ef7')}
        {quti(tr("Jami muddat"), h.jami_matn, tr('{n} kun', { n: h.jami_kun }), '#7c4ff7')}
      </div>

      <div style={{ height: '10px', background: '#f0f0f5', borderRadius: '5px', overflow: 'hidden', marginBottom: '6px' }}>
        <div style={{ width: `${h.foiz}%`, height: '100%', background: rang, transition: 'width .5s' }} />
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', color: '#999' }}>
        <span>{sanaMatn(h.haqiqiy_boshlanish)}</span>
        <span>{h.foiz}%</span>
        <span>{sanaMatn(h.tugaydi)}</span>
      </div>

      {h.hisobga_olingan_kun > 0 && (
        <p style={{ margin: '10px 0 0', fontSize: '12px', color: '#888' }}>
          {tr("Tergov qamog'ida o'tgan {hisobga_olingan_kun} kun hisobga olindi — muddat {sanaMatn} dan emas, {sanaMatn2} dan hisoblanmoqda.", { hisobga_olingan_kun: h.hisobga_olingan_kun, sanaMatn: sanaMatn(h.boshlangan), sanaMatn2: sanaMatn(h.haqiqiy_boshlanish) })}
        </p>
      )}

      {h.qoshilmaydigan_kun > 0 && (
        <p style={{ margin: '6px 0 0', fontSize: '12px', color: '#888' }}>
          {tr("Muddatga qo'shilmaydigan {qoshilmaydigan_kun} kun sababli tugash sanasi shuncha kunga keyinga surildi.", { qoshilmaydigan_kun: h.qoshilmaydigan_kun })}
        </p>
      )}

      {/* 62-band: ATI muddati ishlangan kunlar bilan hisoblanadi. Kalendar
          sanasini haqiqat sifatida ko'rsatish xato bo'lardi. */}
      {h.taxminiy && (
        <div style={{
          background: '#fff8e6', color: '#8a6d2d', padding: '10px 14px',
          borderRadius: '8px', fontSize: '12px', marginTop: '12px', lineHeight: '1.5'
        }}>
          <b>{tr("Bu sana taxminiy.")}</b> {h.taxminiy_izohi}
        </div>
      )}
    </div>
  );
}

// Admin boshqa tumandagi mahkumni ochganda sahifa o'sha tumanga o'tib
// qayta yuklanadi — qaysi yozuv ochilishi kerakligi shu yerda turadi.
const OCHILADIGAN = 'ochiladigan_mahkum';

// Mas'ul inspektor: kim javob beradi, uni almashtirish va tarixi.
function InspektorBolimi({ mahkum, inspektorlar, token, onSaqlandi }) {
  const [tahrir, setTahrir] = useState(false);
  const [tanlangan, setTanlangan] = useState('');
  const [sabab, setSabab] = useState('');
  const [xato, setXato] = useState('');
  const [saqlanmoqda, setSaqlanmoqda] = useState(false);
  const [tarix, setTarix] = useState(null);

  const saqla = async () => {
    setXato('');
    if (!tanlangan) { setXato(tr("Inspektorni tanlang")); return; }
    setSaqlanmoqda(true);
    try {
      await axios.put(`${API}/probatsiya/mahkumlar/${mahkum.id}/inspektor`,
        { inspektor_id: Number(tanlangan), sabab: sabab.trim() },
        { headers: { authorization: token } });
      setTahrir(false); setSabab(''); setTanlangan('');
      if (tarix) tarixniOl();
      onSaqlandi();
    } catch (err) {
      setXato(err.response?.data?.error || tr("Saqlanmadi."));
    } finally {
      setSaqlanmoqda(false);
    }
  };

  const tarixniOl = () => {
    axios.get(`${API}/probatsiya/mahkumlar/${mahkum.id}/inspektorlar`, { headers: { authorization: token } })
      .then(r => setTarix(r.data.tarix))
      .catch(() => setTarix([]));
  };

  return (
    <div style={{ marginTop: '14px', background: '#f6f8fb', borderRadius: '10px', padding: '12px 14px', fontSize: '13px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
        <div>
          <span style={{ color: '#999' }}>{tr("Mas'ul inspektor:")}</span>{' '}
          {mahkum.inspektor_nomi
            ? <b>{mahkum.inspektor_nomi}</b>
            : <span style={{ color: '#c47f17' }}>{tr("biriktirilmagan")}</span>}
        </div>
        <div style={{ display: 'flex', gap: '6px' }}>
          <button onClick={() => { setTahrir(!tahrir); setXato(''); }} style={smallBtn}>
            {tahrir ? tr("Bekor qilish") : tr("O'zgartirish")}
          </button>
          <button onClick={() => (tarix ? setTarix(null) : tarixniOl())} style={smallBtn}>
            {tarix ? tr("Tarixni yopish") : tr("Tarix")}
          </button>
        </div>
      </div>

      {tahrir && (
        <div style={{ display: 'grid', gap: '8px', marginTop: '10px' }}>
          <select value={tanlangan} onChange={e => setTanlangan(e.target.value)} style={inputStyle}
            aria-label={tr("Yangi inspektor")}>
            <option value="">{tr("Yangi inspektorni tanlang")}</option>
            {inspektorlar.filter(i => i.id !== mahkum.inspektor_id).map(i => (
              <option key={i.id} value={i.id}>{i.full_name} — {tr("{soni} ta mahkum", { soni: i.mahkum_soni })}</option>
            ))}
          </select>
          <input type="text" placeholder={tr("Sabab (ixtiyoriy)")} value={sabab}
            onChange={e => setSabab(e.target.value)} style={inputStyle} />
          {xato && <div style={{ color: '#c93636' }}>{xato}</div>}
          <div style={{ textAlign: 'right' }}>
            <button onClick={saqla} disabled={saqlanmoqda}
              style={{ ...smallBtn, background: '#1a1a2e', color: '#fff', border: 'none' }}>
              {saqlanmoqda ? tr("Saqlanmoqda...") : tr("Saqlash")}
            </button>
          </div>
        </div>
      )}

      {tarix && (
        <div style={{ marginTop: '10px' }}>
          {tarix.length === 0 && <div style={{ color: '#999' }}>{tr("Tarix bo'sh")}</div>}
          {tarix.map(t => (
            <div key={t.id} style={{ borderTop: '1px solid #e6e9f0', padding: '6px 0' }}>
              <b>{t.inspektor_nomi}</b>
              <span style={{ color: '#888' }}>
                {' '}· {sanaMatn(t.boshlangan)} — {t.tugagan ? sanaMatn(t.tugagan) : tr("hozirgacha")}
              </span>
              {(t.sabab || t.ozgartirgan_nomi) && (
                <div style={{ color: '#888', fontSize: '12px' }}>
                  {[t.sabab, t.ozgartirgan_nomi && tr("kiritdi: {ism}", { ism: t.ozgartirgan_nomi })]
                    .filter(Boolean).join(' · ')}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// Faqat admin: barcha tumanlardan qidirish.
function AdminQidiruv({ token, onOch }) {
  const [q, setQ] = useState('');
  const [modda, setModda] = useState('');
  const [tuman, setTuman] = useState('hammasi');
  const [tumanlar, setTumanlar] = useState([]);
  const [natija, setNatija] = useState(null);
  const [xato, setXato] = useState('');

  useEffect(() => {
    axios.get(`${API}/districts`, { headers: { authorization: token } })
      .then(r => setTumanlar(r.data.filter(t => t.is_active)))
      .catch(() => {});
  }, [token]);

  useEffect(() => {
    if (q.trim().length < 2 && !modda.trim()) { setNatija(null); setXato(''); return undefined; }
    // Har harf uchun emas — yozib bo'lgach bitta so'rov (jurnal to'lib ketmasin).
    const t = setTimeout(() => {
      axios.get(`${API}/probatsiya/qidiruv`, {
        headers: { authorization: token },
        params: { q: q.trim() || undefined, modda: modda.trim() || undefined, tuman_id: tuman }
      })
        .then(r => { setNatija(r.data); setXato(''); })
        .catch(err => { setNatija(null); setXato(err.response?.data?.error || tr("Qidirib bo'lmadi.")); });
    }, 500);
    return () => clearTimeout(t);
  }, [q, modda, tuman, token]);

  return (
    <div style={{ ...card, marginBottom: '20px' }}>
      <h3 style={{ marginTop: 0, marginBottom: '12px', fontSize: '16px' }}>🔎 {tr("Barcha tumanlardan qidirish")}</h3>
      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
        <input type="text" placeholder={tr("Familiya, ism yoki JSHSHIR")} value={q}
          onChange={e => setQ(e.target.value)} style={{ ...inputStyle, flex: 2, minWidth: '200px', width: 'auto' }} />
        <input type="text" placeholder={tr("JK moddasi (masalan 169)")} value={modda}
          onChange={e => setModda(e.target.value)} style={{ ...inputStyle, flex: 1, minWidth: '140px', width: 'auto' }} />
        <select value={tuman} onChange={e => setTuman(e.target.value)} aria-label={tr("Tuman")}
          style={{ ...inputStyle, flex: 1, minWidth: '160px', width: 'auto' }}>
          <option value="hammasi">{tr("Barcha tumanlar")}</option>
          {tumanlar.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
        </select>
      </div>

      {xato && <p style={{ color: '#c93636', fontSize: '13px', marginBottom: 0 }}>{xato}</p>}
      {natija && (
        <div style={{ marginTop: '12px', overflowX: 'auto' }}>
          <div style={{ color: '#888', fontSize: '12px', marginBottom: '6px' }}>
            {natija.jami > natija.natijalar.length
              ? tr("{jami} ta topildi, birinchi {soni} tasi ko'rsatilgan", { jami: natija.jami, soni: natija.natijalar.length })
              : tr("{jami} ta topildi", { jami: natija.jami })}
          </div>
          {natija.natijalar.length > 0 && (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px', minWidth: '600px' }}>
              <tbody>
                {natija.natijalar.map(m => (
                  <tr key={m.id} style={{ borderTop: '1px solid #f3f3f6' }}>
                    <td style={{ padding: '8px' }}><b>{toliqIsm(m)}</b></td>
                    <td style={{ padding: '8px', color: '#555' }}>🏙️ {m.tuman_nomi}</td>
                    <td style={{ padding: '8px', color: '#666' }}>{m.jk_moddasi || '—'}</td>
                    <td style={{ padding: '8px', color: m.inspektor_nomi ? '#666' : '#c47f17' }}>
                      {m.inspektor_nomi || tr("biriktirilmagan")}
                    </td>
                    <td style={{ padding: '8px', textAlign: 'right' }}>
                      <button onClick={() => onOch(m)} style={smallBtn}>{tr("Ochish")}</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
}

function Mahkumlar() {
  const [mahkumlar, setMahkumlar] = useState([]);
  const [tuman, setTuman] = useState(null);
  const [qidiruv, setQidiruv] = useState('');
  const [yuklanmoqda, setYuklanmoqda] = useState(true);
  const [kirishXatosi, setKirishXatosi] = useState('');

  const [qoshish, setQoshish] = useState(false);
  const [form, setForm] = useState(emptyForm());
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [saving, setSaving] = useState(false);

  const [ochiq, setOchiq] = useState(null);       // ko'rish oynasi
  const [yol, setYol] = useState(null);          // uyga yo'l (navigator)
  const [tahrir, setTahrir] = useState(null);     // tahrirlash oynasi
  const [tahrirXato, setTahrirXato] = useState('');

  const [inspektorlar, setInspektorlar] = useState([]);
  const [biriktirilmagan, setBiriktirilmagan] = useState(0);
  const [inspFiltr, setInspFiltr] = useState('');

  const token = localStorage.getItem('token');
  const admin = adminmi();

  const yukla = useCallback(async () => {
    setYuklanmoqda(true);
    try {
      const res = await axios.get(`${API}/probatsiya/mahkumlar`, { headers: { authorization: token } });
      setMahkumlar(res.data.mahkumlar);
      setTuman(res.data.tuman);
      setKirishXatosi('');
      // Ochiq turgan kartochka yangi ma'lumotni ko'rsatsin (inspektor o'zgarganda).
      setOchiq(eski => (eski ? res.data.mahkumlar.find(m => m.id === eski.id) || null : eski));

      // Admin qidiruvdan boshqa tumandagi mahkumni ochgan bo'lsa.
      const kutilgan = sessionStorage.getItem(OCHILADIGAN);
      if (kutilgan) {
        sessionStorage.removeItem(OCHILADIGAN);
        const topilgan = res.data.mahkumlar.find(m => String(m.id) === kutilgan);
        if (topilgan) setOchiq(topilgan);
      }
    } catch (err) {
      setKirishXatosi(err.response?.data?.error || tr("Ro'yxatni ochib bo'lmadi."));
    } finally {
      setYuklanmoqda(false);
    }
  }, [token]);

  const inspektorlarniOl = useCallback(() => {
    axios.get(`${API}/probatsiya/inspektorlar`, { headers: { authorization: token } })
      .then(r => { setInspektorlar(r.data.inspektorlar); setBiriktirilmagan(r.data.biriktirilmagan); })
      .catch(() => {});
  }, [token]);

  useEffect(() => { yukla(); inspektorlarniOl(); }, [yukla, inspektorlarniOl]);

  const qidiruvdanOch = (m) => {
    if (String(m.district_id) === String(tanlanganTuman())) {
      setOchiq(mahkumlar.find(x => x.id === m.id) || m);
      return;
    }
    tumanniTanla(m.district_id);
    sessionStorage.setItem(OCHILADIGAN, String(m.id));
    window.location.reload();
  };

  const saqla = async () => {
    setError(''); setSuccess('');
    if (!form.familiya.trim() || !form.ism.trim()) { setError(tr("Familiya va ism kiriting")); return; }

    setSaving(true);
    try {
      await axios.post(`${API}/probatsiya/mahkumlar`, form, { headers: { authorization: token } });
      setSuccess(tr("{familiya} {ism} ro'yxatga qo'shildi.", { familiya: form.familiya, ism: form.ism }));
      setForm(emptyForm());
      setQoshish(false);
      yukla();
      inspektorlarniOl();
    } catch (err) {
      setError(err.response?.data?.error || tr("Saqlanmadi."));
    } finally {
      setSaving(false);
    }
  };

  const tahrirSaqla = async () => {
    setTahrirXato('');
    try {
      const res = await axios.put(`${API}/probatsiya/mahkumlar/${tahrir.id}`, tahrir, {
        headers: { authorization: token }
      });
      setSuccess(tr("Ma'lumotlar yangilandi."));
      // Ochiq turgan oyna ham yangi hisobni ko'rsatsin
      if (ochiq?.id === tahrir.id) setOchiq(res.data.mahkum);
      setTahrir(null);
      yukla();
    } catch (err) {
      setTahrirXato(err.response?.data?.error || tr("Saqlanmadi."));
    }
  };

  const hisobdanChiqar = async (m) => {
    setError(''); setSuccess('');
    if (!window.confirm(
      tr("{toliqIsm} hisobdan chiqarilsinmi?\n\nYozuv bazada saqlanib qoladi, faqat ro'yxatda ko'rinmaydi.", { toliqIsm: toliqIsm(m) })
    )) return;

    try {
      await axios.delete(`${API}/probatsiya/mahkumlar/${m.id}`, { headers: { authorization: token } });
      setSuccess(tr("{toliqIsm} hisobdan chiqarildi.", { toliqIsm: toliqIsm(m) }));
      setOchiq(null);
      yukla();
      inspektorlarniOl();
    } catch (err) {
      setError(err.response?.data?.error || tr("Bajarilmadi."));
    }
  };

  const q = qidiruv.trim().toLowerCase();
  const korinadigan = mahkumlar.filter(m =>
    (toliqIsm(m).toLowerCase().includes(q) ||
      (m.jk_moddasi || '').toLowerCase().includes(q) ||
      (m.pinfl || '').includes(q)) &&
    (inspFiltr === '' ||
      (inspFiltr === 'yoq' ? !m.inspektor_id : String(m.inspektor_id) === inspFiltr))
  );

  const muddatiTugagan = mahkumlar.filter(m => m.muddat && !m.muddat.xato && m.muddat.tugadimi).length;
  const yaqinlashgan = mahkumlar.filter(m => m.muddat && !m.muddat.xato && !m.muddat.tugadimi && m.muddat.qolgan_kun <= 30).length;

  if (kirishXatosi) {
    return (
      <div>
        <h2 style={{ marginBottom: '16px', fontSize: '22px' }}>{tr("Mahkumlar reyestri")}</h2>
        <div style={{ ...card, background: '#fff8e6', color: '#8a6d2d' }}>
          {kirishXatosi}
        </div>
      </div>
    );
  }

  return (
    <div>
      <h2 style={{ marginBottom: '6px', fontSize: '22px' }}>{tr("Mahkumlar reyestri")}</h2>
      <p style={{ marginTop: 0, marginBottom: '20px', color: '#888', fontSize: '13px' }}>
        {tuman ? <><b>{tuman.nom}</b> {tr("bo'yicha.")} </> : ''}
        {tr("Siz faqat o'z tumaningiz yozuvlarini ko'rasiz. Har bir ochish va o'zgartirish jurnalga yoziladi.")}
      </p>

      {admin && <AdminQidiruv token={token} onOch={qidiruvdanOch} />}

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '12px', marginBottom: '20px' }}>
        {[
          { label: tr("Hisobda"), value: mahkumlar.length, color: '#1a1a2e' },
          { label: tr("Muddati tugagan"), value: muddatiTugagan, color: '#c93636' },
          { label: tr("30 kundan kam qoldi"), value: yaqinlashgan, color: '#c47f17' },
          { label: tr("Inspektor biriktirilmagan"), value: biriktirilmagan, color: biriktirilmagan ? '#c47f17' : '#1a1a2e' }
        ].map(c => (
          <div key={c.label} style={{ ...card, padding: '18px' }}>
            <div style={{ color: '#888', fontSize: '13px', marginBottom: '6px' }}>{c.label}</div>
            <div style={{ color: c.color, fontSize: '26px', fontWeight: '600' }}>{c.value}</div>
          </div>
        ))}
      </div>

      {success && (
        <div style={{ background: '#e9f9ed', color: '#2d8a2d', padding: '10px 12px', borderRadius: '8px', fontSize: '13px', marginBottom: '14px' }}>
          {success}
        </div>
      )}
      {error && (
        <div style={{ background: '#ffeaea', color: '#c93636', padding: '10px 12px', borderRadius: '8px', fontSize: '13px', marginBottom: '14px' }}>
          {error}
        </div>
      )}

      {qoshish && (
        <div style={{ ...card, marginBottom: '20px' }}>
          <h3 style={{ marginTop: 0, marginBottom: '18px', fontSize: '16px' }}>{tr("Yangi mahkum")}</h3>
          <MahkumForm form={form} setForm={setForm} />
          <div style={{ marginTop: '14px' }}>
            <Maydon label={tr("Mas'ul inspektor")}>
              <select value={form.inspektor_id || ''} onChange={e => setForm({ ...form, inspektor_id: e.target.value })} style={inputStyle}>
                <option value="">{admin ? tr("Biriktirilmagan") : tr("Men (kirituvchi)")}</option>
                {inspektorlar.map(i => <option key={i.id} value={i.id}>{i.full_name}</option>)}
              </select>
            </Maydon>
          </div>
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '18px' }}>
            <button onClick={() => { setQoshish(false); setError(''); }} style={{ ...smallBtn, padding: '10px 20px', fontSize: '14px' }}>
              {tr("Bekor qilish")}
            </button>
            <button
              onClick={saqla}
              disabled={saving}
              style={{
                padding: '10px 24px', background: saving ? '#888' : '#1a1a2e', color: '#fff',
                border: 'none', borderRadius: '8px', fontSize: '14px', cursor: saving ? 'default' : 'pointer'
              }}
            >
              {saving ? tr("Saqlanmoqda...") : tr("Saqlash")}
            </button>
          </div>
        </div>
      )}

      <div style={card}>
        <div style={{ display: 'flex', gap: '10px', marginBottom: '16px', flexWrap: 'wrap' }}>
          <input
            type="text"
            placeholder={tr("🔍 Familiya, ism, JK moddasi yoki JSHSHIR...")}
            value={qidiruv}
            onChange={e => setQidiruv(e.target.value)}
            style={{ ...inputStyle, flex: 1, minWidth: '240px', width: 'auto' }}
          />
          <select value={inspFiltr} onChange={e => setInspFiltr(e.target.value)}
            aria-label={tr("Mas'ul inspektor")}
            style={{ ...inputStyle, width: 'auto', minWidth: '200px' }}>
            <option value="">👮 {tr("Barcha inspektorlar")}</option>
            <option value="yoq">{tr("Inspektor biriktirilmagan")} ({biriktirilmagan})</option>
            {inspektorlar.map(i => (
              <option key={i.id} value={i.id}>{i.full_name} ({i.mahkum_soni})</option>
            ))}
          </select>
          {!qoshish && (
            <button
              onClick={() => { setQoshish(true); setSuccess(''); }}
              style={{
                padding: '10px 20px', background: '#1a1a2e', color: '#fff',
                border: 'none', borderRadius: '8px', fontSize: '14px', cursor: 'pointer', whiteSpace: 'nowrap'
              }}
            >
              + {tr("Mahkum qo'shish")}
            </button>
          )}
        </div>

        {yuklanmoqda && <p style={{ color: '#999', fontSize: '14px' }}>{tr("Yuklanmoqda...")}</p>}

        {!yuklanmoqda && (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px', minWidth: '860px' }}>
              <thead>
                <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                  {[tr("F.I.Sh"), tr("JK moddasi"), tr("Mas'ul inspektor"), tr("Jazo muddati"), tr("Tugash sanasi"), tr("Holati"), ''].map((h, i) => (
                    <th key={h + i} style={{
                      textAlign: i === 6 ? 'right' : 'left',
                      padding: '10px 8px', color: '#888', fontWeight: '500'
                    }}>
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {korinadigan.map(m => {
                  const h = m.muddat;
                  const ok = h && !h.xato;
                  return (
                    <tr key={m.id} style={{ borderBottom: '1px solid #f9f9f9' }}>
                      <td style={{ padding: '10px 8px' }}>
                        <div style={{ fontWeight: '500' }}>{toliqIsm(m)}</div>
                        <div style={{ color: '#999', fontSize: '12px' }}>
                          {[m.tugilgan_sana && sanaMatn(m.tugilgan_sana) + ' t.', m.jazo_turi].filter(Boolean).join(' · ')}
                        </div>
                      </td>
                      <td style={{ padding: '10px 8px', color: '#666', fontSize: '13px' }}>{m.jk_moddasi || '—'}</td>
                      <td style={{ padding: '10px 8px', fontSize: '13px', color: m.inspektor_nomi ? '#666' : '#c47f17' }}>
                        {m.inspektor_nomi || tr("biriktirilmagan")}
                      </td>
                      <td style={{ padding: '10px 8px', color: '#666' }}>{ok ? h.jami_matn : '—'}</td>
                      <td style={{ padding: '10px 8px', color: '#666' }}>{ok ? sanaMatn(h.tugaydi) : '—'}</td>
                      <td style={{ padding: '10px 8px', minWidth: '150px' }}>
                        {ok ? (
                          <>
                            <div style={{ height: '6px', background: '#f0f0f5', borderRadius: '3px', overflow: 'hidden' }}>
                              <div style={{ width: `${h.foiz}%`, height: '100%', background: holatRangi(h) }} />
                            </div>
                            <div style={{ fontSize: '11px', color: holatRangi(h), marginTop: '3px' }}>
                              {h.tugadimi ? tr("Muddati tugagan") : tr("{foiz}% · {qolgan_kun} kun qoldi", { foiz: h.foiz, qolgan_kun: h.qolgan_kun })}
                            </div>
                          </>
                        ) : (
                          <span style={{ color: '#c47f17', fontSize: '12px' }}>{tr("Muddat kiritilmagan")}</span>
                        )}
                      </td>
                      <td style={{ padding: '10px 8px', textAlign: 'right', whiteSpace: 'nowrap' }}>
                        <button onClick={() => setOchiq(m)} style={smallBtn}>{tr("Ochish")}</button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>

            {korinadigan.length === 0 && (
              <p style={{ color: '#999', fontSize: '14px', textAlign: 'center', margin: '20px 0 0' }}>
                {mahkumlar.length === 0
                  ? tr("Reyestr bo'sh. \"Mahkum qo'shish\" tugmasi bilan boshlang.")
                  : tr("Hech narsa topilmadi.")}
              </p>
            )}
          </div>
        )}
      </div>

      {/* Ko'rish oynasi */}
      {ochiq && (
        <div
          onClick={() => setOchiq(null)}
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', zIndex: 100
          }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{
              background: '#fff', borderRadius: '12px', padding: '24px',
              width: '100%', maxWidth: '640px', maxHeight: '90vh', overflowY: 'auto'
            }}
          >
            <h3 style={{ marginTop: 0, marginBottom: '4px', fontSize: '18px' }}>{toliqIsm(ochiq)}</h3>
            <p style={{ marginTop: 0, marginBottom: '18px', color: '#999', fontSize: '13px' }}>
              {[ochiq.jk_moddasi, ochiq.jazo_turi].filter(Boolean).join(' · ') || tr("Hukm ma'lumoti kiritilmagan")}
            </p>

            <MuddatPaneli h={ochiq.muddat} />

            <InspektorBolimi
              key={ochiq.id}
              mahkum={ochiq}
              inspektorlar={inspektorlar}
              token={token}
              onSaqlandi={() => { setSuccess(tr("Mas'ul inspektor o'zgartirildi.")); yukla(); inspektorlarniOl(); }}
            />

            <div style={{ marginTop: '18px', borderTop: '1px solid #f0f0f5', paddingTop: '14px', fontSize: '13px', color: '#666', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
              <div><b style={{ color: '#999', fontWeight: '400' }}>{tr("Tug'ilgan:")}</b> {sanaMatn(ochiq.tugilgan_sana)}</div>
              <div><b style={{ color: '#999', fontWeight: '400' }}>{tr("JSHSHIR:")}</b> {ochiq.pinfl || '—'}</div>
              <div><b style={{ color: '#999', fontWeight: '400' }}>{tr("Sud:")}</b> {ochiq.sud_nomi || '—'}</div>
              <div><b style={{ color: '#999', fontWeight: '400' }}>{tr("Hukm sanasi:")}</b> {sanaMatn(ochiq.hukm_sanasi)}</div>
              <div><b style={{ color: '#999', fontWeight: '400' }}>{tr("Ish raqami:")}</b> {ochiq.ish_raqami || '—'}</div>
              <div><b style={{ color: '#999', fontWeight: '400' }}>{tr("Nazoratga olingan:")}</b> {sanaMatn(ochiq.nazoratga_olingan)}</div>
              <div style={{ gridColumn: '1 / -1' }}>
                <b style={{ color: '#999', fontWeight: '400' }}>{tr("Manzil:")}</b> {ochiq.manzil || '—'}
              </div>
              {ochiq.izoh && (
                <div style={{ gridColumn: '1 / -1' }}>
                  <b style={{ color: '#999', fontWeight: '400' }}>{tr("Izoh:")}</b> {ochiq.izoh}
                </div>
              )}
            </div>

            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '20px', flexWrap: 'wrap' }}>
              <button onClick={() => hisobdanChiqar(ochiq)} style={{ ...smallBtn, padding: '10px 18px', fontSize: '14px', color: '#c93636' }}>
                {tr("Hisobdan chiqarish")}
              </button>
              {/* Uyga yo'l — begona tumanga qo'qqisdan tekshiruvga
                  chiqqan xodim manzil matni bilan uyni topa olmaydi. */}
              <button onClick={() => setYol(ochiq)} style={{ ...smallBtn, padding: '10px 18px', fontSize: '14px', marginRight: 'auto' }}>
                {tr("Uyga yo'l")}
              </button>
              <button
                onClick={() => {
                  setTahrirXato('');
                  // Sana maydonlari input[type=date] uchun YYYY-MM-DD bo'lishi kerak
                  const s = (v) => (v ? String(v).slice(0, 10) : '');
                  setTahrir({
                    ...ochiq,
                    tugilgan_sana: s(ochiq.tugilgan_sana),
                    hukm_sanasi: s(ochiq.hukm_sanasi),
                    jazo_boshlangan: s(ochiq.jazo_boshlangan),
                    nazoratga_olingan: s(ochiq.nazoratga_olingan),
                    sharif: ochiq.sharif || '', manzil: ochiq.manzil || '', pinfl: ochiq.pinfl || '',
                    sud_nomi: ochiq.sud_nomi || '', ish_raqami: ochiq.ish_raqami || '',
                    jk_moddasi: ochiq.jk_moddasi || '', jazo_turi: ochiq.jazo_turi || '',
                    izoh: ochiq.izoh || ''
                  });
                }}
                style={{ ...smallBtn, padding: '10px 18px', fontSize: '14px' }}
              >
                {tr("Tahrirlash")}
              </button>
              <button
                onClick={() => setOchiq(null)}
                style={{ padding: '10px 24px', background: '#1a1a2e', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '14px', cursor: 'pointer' }}
              >
                {tr("Yopish")}
              </button>
            </div>
          </div>
        </div>
      )}

      {yol && <YolKorsat mahkum={yol} onYopish={() => setYol(null)} />}

      {/* Tahrirlash oynasi */}
      {tahrir && (
        <div
          onClick={() => setTahrir(null)}
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', zIndex: 110
          }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{
              background: '#fff', borderRadius: '12px', padding: '24px',
              width: '100%', maxWidth: '760px', maxHeight: '90vh', overflowY: 'auto'
            }}
          >
            <h3 style={{ marginTop: 0, marginBottom: '18px', fontSize: '18px' }}>{tr("Ma'lumotlarni tahrirlash")}</h3>
            <MahkumForm form={tahrir} setForm={setTahrir} />

            {tahrirXato && (
              <div style={{ background: '#ffeaea', color: '#c93636', padding: '10px 12px', borderRadius: '8px', fontSize: '13px', marginTop: '12px' }}>
                {tahrirXato}
              </div>
            )}

            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '18px' }}>
              <button onClick={() => setTahrir(null)} style={{ ...smallBtn, padding: '10px 20px', fontSize: '14px' }}>
                {tr("Bekor qilish")}
              </button>
              <button
                onClick={tahrirSaqla}
                style={{ padding: '10px 24px', background: '#1a1a2e', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '14px', cursor: 'pointer' }}
              >
                {tr("Saqlash")}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Mahkumlar;
